import { render, staticRenderFns } from "./channelContent.vue?vue&type=template&id=dade589c&scoped=true"
import script from "./channelContent.vue?vue&type=script&lang=js"
export * from "./channelContent.vue?vue&type=script&lang=js"
import style0 from "./channelContent.vue?vue&type=style&index=0&id=dade589c&prod&lang=scss&scoped=true"
import style1 from "./channelContent.vue?vue&type=style&index=1&id=dade589c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dade589c",
  null
  
)

export default component.exports